<template>
  <ListLoader
    class="position-relative h-100"
    :is-crashed="isCrashed"
    :is-empty-list="!tournaments.length"
    :dummy-props="{
      iconName: dummyIcon,
      size: 200,
      headerText: $$t('Competitions list is empty.', 'no-results'),
      text: dummyText,
    }"
    @reload="reloadTournaments"
  >
    <Paginated
      slot="list"
      v-bind="{
        totalItems,
        hidePagination: !tournaments.length,
        pageSize,
        inContainer: true,
      }"
      class="mb-0 h-auto"
      @change="fetchTournaments"
    >
      <div
        v-for="col in grid"
        :key="`column_${col}_${grid}`"
        ref="columns"
        class="col d-flex flex-column"
        :class="`col-${12 / grid}`"
      >
        <template v-for="(tournament, tournamentIndex) in tournaments">
          <div
            v-if="(tournamentIndex - col + 1) % grid === 0"
            :key="`tournament_${tournament.id || tournamentIndex}`"
            class="mb-5"
          >
            <TournamentCard
              v-if="tournament"
              v-bind="{ tournament, forOrganizer: false }"
            />
            <ContentLoader v-else :variant="$options.TOURNAMENT_CARD_LOADER" />
          </div>
        </template>
      </div>
    </Paginated>
  </ListLoader>
</template>

<script>
import { TOURNAMENT_CARD_LOADER } from '@/constants/loaders';
import { arrayOfEmptyObject, prop, propRequired } from '@/utils/factories';
import listMixin from '@/mixins/paginatedLists';
import { translate } from '@/mixins/translate';
import ContentLoader from '@/components/common/Loaders/index';
import Paginated from '@/components/common/Paginated';
import TournamentCard from '@/components/common/TournamentCard';
import ListLoader from '@/components/common/HeraListPreloader';
import {
  addGlobalEventListener,
  removeGlobalEventListener,
} from '@/utils/globalEvent';

export default {
  name: 'TournamentsList',
  components: {
    ContentLoader,
    Paginated,
    TournamentCard,
    ListLoader,
  },
  mixins: [...listMixin, translate('_web_competitions_list')],
  props: {
    dataSource: propRequired(Function),
    queryParams: prop(Object),
    dummyIcon: prop(String, 'search'),
    dummyText: prop(String),
  },
  data() {
    return {
      tournaments: [],
      tournamentsSkeleton: arrayOfEmptyObject()(12),
      grid: 2,
    };
  },
  watch: {
    queryParams: {
      deep: true,
      handler() {
        this.reloadTournaments();
      },
    },
  },
  created() {
    this.fetchTournaments();
    this.$options.TOURNAMENT_CARD_LOADER = TOURNAMENT_CARD_LOADER;
    this.calcGrid();
    addGlobalEventListener('resize.grid_cards', this.calcGrid);
  },
  beforeDestroy() {
    removeGlobalEventListener('.grid_cards');
  },
  methods: {
    fetchTournaments(newPage) {
      this.pageIndex = newPage;
      return this.getPageData(
        'tournaments',
        this.dataSource(
          this.paramsWithPageNumber({
            ...this.queryParams,
          })
        ),
        {
          uniqBy: 'id',
        }
      );
    },
    reloadTournaments() {
      this.tournaments = [];
      this.pageIndex = 0;
      this.fetchTournaments();
    },
    calcGrid() {
      this.grid = window.innerWidth > 1200 ? 2 : 1;
    },
  },
};
</script>
<style lang="scss">
.player-tournaments-list {
  &_items-row {
    $gutter: 0.625rem;
    margin-left: -$gutter;
    margin-right: -$gutter;
    & > * {
      padding-left: $gutter;
      padding-right: $gutter;
    }
  }

  &_sortby-btn {
    top: 0.5rem;
    @include auto-rtl(right, 0);
    z-index: 3;
  }
}
</style>
